import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import EditName from "./editName";
import {
  EmailEditorLayout,
  ReviewAddresses,
  EditAltEmail,
  AddAltEmail,
} from "./editEmails";

function BasicSection() {
  return (
    <Routes>
      <Route path="name" element={<EditName />} />
      <Route path="emails" element={<EmailEditorLayout />}>
        <Route index element={<ReviewAddresses />} />
        <Route path="edit/:emailId" element={<EditAltEmail />} />
        <Route path="add" element={<AddAltEmail />} />
      </Route>
      <Route path="*" element={<Navigate to="./.." replace />} />
    </Routes>
  );
}

export default BasicSection;
